import { get as getClientConfig } from 'dynamic-data/config';

export default getClientConfig;
